<template>
  <section class="grid grid-columns-2 grid-columns-3_sm grid-columns-5_lg mb4">
    <div class="grid-column-full align-self-end">
      <h2 class="mb0 mt2">Annual revenue targets</h2>
      <p class="font-size-2 mb0">The revenue you need to support your goals</p>
    </div>

    <lw-card
      :title="'Target annual revenue'"
      :url="{ name: 'ar', params: { id: page }}"
      :colour="'reverse'"
      :value="rate.goal.incoming"
      :class="'grid-column-span-2_lg'"
    />

    <lw-card
      :title="'Revenue per employee'"
      :url="{ name: 'rfte', params: { id: page }}"
      :colour="'reverse'"
      :value="rate.goal.incomingPerEmployee"
      :class="'grid-column-span-1'"
    />

    <lw-card
      :title="'Average client value'"
      :url="{ name: 'acs', params: { id: page }}"
      :colour="'reverse'"
      :value="rate.goal.incomingPerClient"
      :class="'grid-column-span-1'"
    />

    <div class="mt2 grid-column-full  align-self-end">
      <h2 class="mb0">Minimum rates</h2>
      <p class="font-size-2 mb0">Charge no less than this to meet your targets</p>
    </div>

    <lw-card
      :title="'Month'"
      :url="{ name: 'month', params: { id: page }}"
      :colour="'reverse'"
      :value="rate.monthRate"
      :unit="'/person/client'"
      :class="'grid-column-span-1'"
    />

    <lw-card
      :title="'Sprint'"
      :url="{ name: 'sprint', params: { id: page }}"
      :colour="'reverse'"
      :value="rate.sprintRate"
      :unit="'/person/client'"
      :class="'grid-column-span-1'"
    />

    <lw-card
      :title="'Week'"
      :url="{ name: 'week', params: { id: page }}"
      :colour="'reverse'"
      :value="rate.weekRate"
      :unit="'/person/client'"
      :class="'grid-column-span-1'"
    />

    <lw-card
      :title="'Day'"
      :url="{ name: 'day', params: { id: page }}"
      :colour="'reverse'"
      :value="rate.dayRate"
      :unit="'/person'"
      :class="'grid-column-span-1'"
    />

    <lw-card
      :title="'Hour'"
      :url="{ name: 'hour', params: { id: page }}"
      :colour="'reverse'"
      :value="rate.hourRate"
      :unit="'/person'"
      :class="'grid-column-span-1'"
    />
  </section>
</template>

<script>
import Card from '../livewires/Card'

export default {
  components: {
    lwCard: Card
  },
  data () {
    return {
      page: this.$route.params.id
    }
  },
  computed: {
    rate () {
      return this.$store.getters.rateCard(this.page)
    }
  }
}
</script>
